import { DateTime } from 'luxon';
import { Badge } from 'react-bootstrap';
import type { TeamCompetitorCompSummary } from '../types/api.types';

interface MemberTeamHistoryProps {
  history: TeamCompetitorCompSummary[];
}

export default function MemberTeamHistory({ history }: MemberTeamHistoryProps) {
  if (!history || history.length === 0) {
    return null;
  }

  const record = history.map((result) => (
    <tr className={result.winningTeam === result.team ? 'highlight-win' : undefined} key={result.date}>
      <td>{result.date ? DateTime.fromISO(result.date).year : ''}</td>
      <td>{result.venue}</td>
      <td>
        <Badge className={result.team === 'EUR' ? 'team-eur' : 'team-usa'}>{result.team}</Badge>
        <span>{result.captain ? ' (C)' : ''}</span>
      </td>
      <td>{result.winningTeam === result.team ? 'WON' : 'LOST'}</td>
      <td>{`${parseFloat(String(result.pointsScored || '0'))} (${result.availablePoints || 0})`}</td>
    </tr>
  ));

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Year</th>
          <th>Venue</th>
          <th>Team</th>
          <th>Result</th>
          <th>Points</th>
        </tr>
      </thead>
      <tbody>{record}</tbody>
    </table>
  );
}
